import {Injectable} from '@angular/core';
import {Game} from '../domain/game';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GameService {
  constructor(private httpClient: HttpClient) {
  }

  createGame(game: Game): Observable<Game> {
    return this.httpClient.post<Game>(`/api/spelgemma.php`, game);
  }

  getGame(id: string): Observable<Game> {
    return this.httpClient.get<Game>(`/api/spelgemma.php?id=${id}`);
  }

  updateGame(game: Game): Observable<Game> {
    return this.httpClient.put<Game>(`/api/spelgemma.php?id=${game.id}`, game);
  }
}
